import { Component, OnInit } from '@angular/core';
import { BaseClass } from '../../../../shared/base-class';
import { PolicySummaryData } from '../../data/policy-summary.data';

@Component({
  selector: 'app-optional-coverages-limits',
  templateUrl: './optional-coverages-limits.component.html',
  styleUrls: ['./optional-coverages-limits.component.scss']
})
export class OptionalCoveragesLimitsComponent extends BaseClass implements OnInit {
  public isOpen: boolean = true;

  constructor(public policySummaryData: PolicySummaryData) {
    super();
  }

  ngOnInit() {
  }

  collapse(): void {
    this.isOpen = !this.isOpen;
  }
}
